/**
 * Single Sign On Status Page
 */

import React from 'react';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import { faSignInAlt } from '@fortawesome/pro-solid-svg-icons';

import Icon from '../../atoms/icon';
import Meta from '../../atoms/meta';
import Card from '../../organisms/card';
import Callout from '../../organisms/callout';
import Button from '../../molecules/button';

enum SSOError {
  Authentication = 'authentication',
  Authorization = 'authorization'
}

const getErrorMessage = (error: SSOError): JSX.Element => {
  if (error === SSOError.Authentication) {
    return (
      <div>
        <Callout intent="danger">
          Sorry, your identity cannot be authenticated. Please try again or
          contact the administrator of your organization for help.
        </Callout>
      </div>
    );
  } else if (error === SSOError.Authorization) {
    return (
      <div>
        <Callout intent="primary">
          Sorry, you do not have permission to access CareSignal. If you believe
          this is a mistake, please contact the administrator of your
          organization for help.
        </Callout>
      </div>
    );
  }
  return null;
};

const SSOStatusPage: React.FC = () => {
  const { search } = useLocation();
  let error: SSOError = null;
  if (search?.length) {
    const query = qs.parse(search, {
      ignoreQueryPrefix: true
    });
    if (query.error) {
      error = query.error as SSOError;
    }
  }
  return (
    <Card className="mb-8">
      <Meta title="Single Sign On" />
      <h1 className="text-sans-lg mb-7">
        <Icon icon={faSignInAlt} /> Single Sign On
      </h1>
      {getErrorMessage(error)}
      <Button className="mt-8" fill linkTo="/">
        Back to Login
      </Button>
    </Card>
  );
};

export default SSOStatusPage;
